import { UserConfig } from '@api/type';

export const SetUserConfigActionType = 'SetUserConfig';
export const SetHrisDomainActionType = 'SetHrisDomain';

export type ConfigState = { hrisDomain: string } & UserConfig;

export type ConfigPayload = { hrisDomain: string } | UserConfig;

interface SetUserCofigAction {
  type: typeof SetUserConfigActionType | typeof SetHrisDomainActionType;
  payload: ConfigPayload;
}

export type ConfigAction = SetUserCofigAction;
